module.exports = __webpack_public_path__ + "static/wiring-d1f5cd1b72b6de826257cce2fa385c1c.jpg";